import React, { useContext, useEffect } from 'react';
import { b2cPagesService } from '@clubmed/utils';
import { ToasterImmersive } from 'Components/frameworks/toaster-immersive/ToasterImmersive';
import { ICONS } from 'Components/utils/icon/icons';
import { FavoriteProductListContext } from 'Context/FavoriteProductListContext';
import { usePageContext } from 'Context/PageContext';
import { useAuthentication } from 'Src/hooks/use-authentication/useAuthentication';
import { t } from 'Src/i18n';
export const PriceRemoteMaximumFavoriteToaster = ({
  setIsVisible,
}: {
  setIsVisible?: (arg0: boolean) => void;
}) => {
  const {
    favoriteProductsState: { favoriteProductList, hasTooManyFavorites },
    setFavoriteProductList,
    setHasTooManyFavorites,
  } = useContext(FavoriteProductListContext);
  const { isLogged, isQuickLogged } = useAuthentication();
  const { pageType } = usePageContext();
  const { PAGE_TYPES } = b2cPagesService;
  const isAllowedPage = [PAGE_TYPES.RESORT].includes(pageType);
  const displayToaster = !isLogged && !isQuickLogged && hasTooManyFavorites && isAllowedPage;
  useEffect(() => {
    setIsVisible?.(displayToaster);
  }, [displayToaster]);
  return (
    displayToaster && (
      <ToasterImmersive
        text={t('common.favoriteOption.favoriteTooltip.editFavorite')}
        title={t('common.favoriteOption.favoriteTooltip.maximumLabel')}
        iconName={ICONS.WARNING}
        onClick={() => {
          setFavoriteProductList(favoriteProductList, false, displayToaster);
          setIsVisible?.(false);
        }}
        onClose={() => {
          setIsVisible?.(false);
          setHasTooManyFavorites(false);
        }}
      />
    )
  );
};
